<template>
  <!-- 消耗品発送指示 -->
  <div id="AppMasterMaintenaceDisposableOrder">
      <!-- 上部余白 -->
      <div style="height: 20px;" />
      <div style="margin-left: 50px; margin-right: 50px;">
        <div class="columns">
          <!-- <div class="column is-half">
            <b-field class="file">
              <b-button
                class="button is-primary has-text-centered"
                icon-left="download"
                native-type="button"
                v-on:click="doDownload">消耗品発送指示ダウンロード</b-button>    
            </b-field>
          </div> -->
           <div class="column is-half">
            <b-field class="file">
              <b-button
                class="button is-primary has-text-centered"
                icon-left="download"
                native-type="button"
                v-on:click="doTeikiDownload">消耗品発送登録ダウンロード</b-button> 
            </b-field>
          </div>
        </div>
      </div>
      <!-- 下部余白 -->
      <div style="height: 10px;" />
  </div>
</template>

<script>
export default {
  name: 'AppMasterMaintenaceDisposableOrder',
  methods: {
  //  doDownload: function () {
  //     var excuteApi = this.downloadDispoDeliveryHistoryFilePOST
  //     var errorCallBack = this.downloadFileError
  //     // WebAPI Call
  //     this.downloadApiCall(excuteApi,errorCallBack)
  //   },
  //   downloadDispoDeliveryHistoryFilePOST: function (client) {
  //     return client.apis.apiMaster.downloadDispoDeliveryHistoryFilePOST({
  //     })
  //   },
  //   downloadFileError: function (result) {
  //     this.showErrorMessage(result)
  //   },
    
   doTeikiDownload: function () {
      var excuteApi = this.downloadRegularDispoDeliveryFilePOST
      var errorCallBack = this.downloadFileError
      // WebAPI Call
      this.downloadApiCall(excuteApi,errorCallBack)
    },
    downloadRegularDispoDeliveryFilePOST: function (client) {
      return client.apis.apiMaster.downloadRegularDispoDeliveryFilePOST({
      })
    },
    downloadFileError: function (result) {
      this.showErrorMessage(result)
    }
  },
  data () {
    return {
      file: null,
    }
  },
  filters: {
  },
  components: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AppMasterMaintenaceDisposableOrder.vue